// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"141":"b340e894","246":"5de62c24","287":"982368ea","326":"7dbbd235","394":"62e37026","435":"80941233","552":"2f327c2d","571":"6bc0aaec","603":"72c2abd5","646":"8001b7c7","671":"6047b122","880":"8c8314e8","888":"946143f1","965":"0b08c4a9"}[chunkId] + ".chunk.js";
};